export default {
  BASE_URL: '/sys/role',
  api: [
    {
      name: 'list',
      desc: '获取角色列表',
      method: 'GET',
      path: 'list/{code}'
    },
    {
      name: 'insert',
      desc: '新增角色',
      method: 'POST',
      path: 'add'
    },
    {
      name: 'update',
      desc: '编辑角色',
      method: 'PUT',
      path: 'edit'
    },
    {
      name: 'delete',
      desc: '删除角色',
      method: 'DELETE',
      path: 'delete/{id}'
    },
    {
      name: 'toggleStatus',
      desc: '启用/停用角色',
      method: 'PUT',
      path: 'isEnable'
    },
    {
      name: 'checkName',
      desc: '校验角色名称是否存在',
      method: 'GET',
      path: 'checkName'
    },
    {
      name: 'users',
      desc: '获取某个角色下关联的所有用户',
      method: 'GET',
      path: 'userList'
    },
    {
      name: 'addUser',
      desc: '添加用户',
      method: 'PUT',
      path: 'addUser'
    },
    {
      name: 'deleteUser',
      desc: '删除用户',
      method: 'DELETE',
      path: 'deleteUser'
    },
    {
      name: 'allUser',
      desc: '获取应用下的所有的用户',
      method: 'GET',
      path: 'allUser'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/role/index.js